var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 9.39758V6.89758H6.60718M1.10718 1.39758V3.89758L3.60718 3.89758M9.07623 4.89758C8.83018 2.92443 7.14699 1.39758 5.10718 1.39758C3.62661 1.39758 2.33393 2.20198 1.64231 3.39758M1.13812 5.89758C1.38417 7.87074 3.06737 9.39758 5.10718 9.39758C6.58774 9.39758 7.88043 8.59318 8.57205 7.39758",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5594a3f334668e70d23daba84bbfad00.svg";
export { ForwardRef as ReactComponent };